module.exports = __webpack_public_path__ + "static/media/icono.a6fcaa13.svg";